import { Alert, AlertTitle, Link } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { FamilyMemberDuplicationCheckDTO } from '@/api/DTO/family/family.interface';

/**
 * DMS-REQ-WEB-CHA-005: shown on the register form when a family member was
 * picked to link; the link is sent with the register request.
 */
export default function PendingFamilyMemberLinkAlert({
	familyMember,
}: {
	familyMember: FamilyMemberDuplicationCheckDTO;
}) {
	const { t } = useTranslation();
	return (
		<Alert severity='info' sx={{ marginBottom: '12px' }}>
			<AlertTitle>{t('identityLink.pendingFamilyMemberLinkTitle')}</AlertTitle>
			<Trans
				i18nKey='identityLink.pendingFamilyMemberLink'
				values={{
					fileNo: familyMember.familyMemberFileNo,
					name: [familyMember.nameEn, familyMember.nameZh]
						.filter(Boolean)
						.join(' '),
				}}
				components={{
					anchor: (
						<Link
							href={`/family-management/family-management-list/detail/${familyMember.id}`}
							target='_blank'
							rel='noopener noreferrer'
							color='#1BBED7'
						/>
					),
				}}
			/>
		</Alert>
	);
}
